import { render, staticRenderFns } from "./BaseCsvModal.vue?vue&type=template&id=ca2fc152&scoped=true"
import script from "./BaseCsvModal.vue?vue&type=script&lang=js"
export * from "./BaseCsvModal.vue?vue&type=script&lang=js"
import style0 from "./BaseCsvModal.vue?vue&type=style&index=0&id=ca2fc152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2fc152",
  null
  
)

export default component.exports